import { Option } from '@joor/design-system'

export enum FieldIds {
  AddressOption = 'addressOption',
  CompanyName = 'companyName',
  RecipientName = 'recipientName',
  Address1 = 'address1',
  Address2 = 'address2',
  City = 'city',
  Country = 'country',
  ShippingCode = 'shippingCode',
  Email = 'email',
  Territory = 'territory',
  PostalCode = 'postalCode',
  Phone = 'phone',
  Door = 'door',
  TrackingNumber = 'trackingNumber',
  ShippingMethod = 'shippingMethod',
}

export type ShippingAddressFormValues = {
  [FieldIds.AddressOption]: Option | null
  [FieldIds.CompanyName]: string
  [FieldIds.RecipientName]: string
  [FieldIds.Email]?: string
  [FieldIds.Address1]: string
  [FieldIds.Address2]: string
  [FieldIds.City]: string
  [FieldIds.Territory]: string
  [FieldIds.Country]: Option | null
  [FieldIds.PostalCode]: string
  [FieldIds.Phone]: string
  [FieldIds.ShippingCode]?: string
  [FieldIds.Door]?: Option | null | string
  [FieldIds.TrackingNumber]?: string
  [FieldIds.ShippingMethod]?: Option | null
}

export const EMPTY_FORM_STATE: ShippingAddressFormValues = {
  [FieldIds.AddressOption]: null,
  [FieldIds.CompanyName]: '',
  [FieldIds.RecipientName]: '',
  [FieldIds.Email]: '',
  [FieldIds.Address1]: '',
  [FieldIds.Address2]: '',
  [FieldIds.City]: '',
  [FieldIds.Territory]: '',
  [FieldIds.Country]: null,
  [FieldIds.PostalCode]: '',
  [FieldIds.ShippingCode]: '',
  [FieldIds.Phone]: '',
}
